"use client"

import { MapPinOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinOffIcon = component(Icon)({ as: MapPinOff })
